import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchIntegratedPlatform,destoryStore,resetNotification } from './integratedSlice';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import Card from '@mui/material/Card';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import PlatformImage from '../../General/PlatformImage'
import PlatformDrawer from '../../General/PlatformDrawer';
import SettingsStatus from '../../../pages/General/SettingsStatus'
import Notification from '../../../pages/General/Notification'

const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
const IntegratedPage = ({ loading, data }) => {
    const integrate = useSelector(state => state.integrated && state.integrated);
    const integrated = useSelector(state => state.integrated);
    
    const [currentCategory, setCurrentCategory] = useState('all');
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [platformName, setPlatformName] = useState('all');
    const [storeName, setStoreName] = useState('all');
    const [storeId, setStoreId] = useState('all');
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const platformCallback = (platform,name,id) => {
        if(platform==='SHOPIFY_APP'){
            platform='SHOPIFY'
        }       
        setPlatformName(platform)
        setStoreName(name)
        setStoreId(id)    
        setOrderDrawerVisible(true)
    }
    
    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };
    const handleClick = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };
     const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deleteStore = (id) => {
        dispatch(destoryStore({"store_id":id}))
        setDeleteModalopen(false);
    }

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchIntegratedPlatform())
    }, [dispatch])

    const columns = [
        {
            field: "platform",
            headerName: 'Platform',
            width:100,
            resizable: false,           
            renderCell: (params) => {
                return (
                    <PlatformImage platform={params.row.platform} width={"35px"} />
                )
            }
        },
        { field: 'store_name', headerName: 'Store',width:300,resizable: false, flex: 1 },
        { field: 'is_installed', 
        headerName: 'Status',
         minWidth:50,
         resizable: false,
        renderCell: (params) => {
            return <SettingsStatus settingsStatus={params.row.is_installed} />
        } },
        {
            field: 'Actions',
            resizable: false,
            minWidth:100,
            renderCell: (params) => {
                return (
                    <div>
                        <span
                            style={{ marginRight: '10px' }}
                        >
                            <EditIcon
                                style={{ color: '#1890ff', cursor: 'pointer' }}
                                onClick={(e) => {
                                    platformCallback(params.row.platform,params.row.store_name,params.row.store_id)
                                }}
                            />
                        </span>
                        {params && params.row && params.row.platform && params.row.platform==="ZONOS" &&
                            <span>
                                <Tooltip title="Delete" placement="left-start">
                                    <DeleteOutlineOutlinedIcon style={{ color: '#1890ff', cursor: 'pointer' }}
                                        onClick={(e) => {
                                            handleClick(params.row.store_id)
                                        }}
                                    />
                                </Tooltip>
                            </span>
                        }
                    </div>
                )

            }
        }
    ];

    return (
        <>
            {(integrated && integrated.notification && integrated.notification.show) &&
                <Notification
                    is_open={integrated.notification.show}
                    messageType={integrated.notification.messageType}
                    messages={integrated.notification.messageContent}
                    handleClose={() => dispatch(resetNotification())}
             />}
            {loading && <Card loading={loading} />}
            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={deleteModalStyle}>
                    <Typography sx={{ p: 2 }}>Are you sure want to delete this Store?<br />
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <span style={{ margin: '0 10px' }}>
                                <Button
                                    variant="contained"
                                    style={{ margin: "10px 0" }}
                                    onClick={(event) => {
                                        deleteStore(deleteid)
                                    }}
                                >
                                    Yes
                                </Button>
                            </span>
                            <span>
                                <Button
                                    variant="outlined"
                                    style={{ margin: "10px 0" }}
                                    onClick={deleteModalClose}
                                >
                                    No
                                    </Button>
                            </span>
                        </div>
                    </Typography>
                </Box>
            </Modal>
            <div className="integrated--stores--title">
                <h2 style={{ textAlign: 'left' }}>Connected Market Places</h2>
            </div>
            <div className="integrated--stores--list">
                <div style={{ width: '100%' }}>
                    <DataGrid
                        getRowId={(row) => row.store_id}
                        rows={integrate && integrate.data}
                        columns={columns}
                        autoHeight={true}
                        disableRowSelectionOnClick
                        disableColumnFilter={true}
                        disableColumnMenu={true}
                        hideFooter={true}
                        slots={{
                            loadingOverlay: LinearProgress,
                          }}
                        loading={
                            (integrate && integrate.loading)
                        }
                    />
                </div>
            </div>
            <PlatformDrawer
                visible={orderDrawerVisible}
                onClose={orderOnClose}
                platform={platformName}
                storeName={storeName}
                storeId={storeId}
            />

        </>
    )
}

export default IntegratedPage
